import { DomainEnum, FeatureIdEnum, FirstLoginStepEnum, LocaleEnum } from '../enums';

import { AppMessages, Dictionary } from '../models';

/* tslint:disable:max-line-length */

const supportLink = 'https://support.empathy.co';

const APP_MESSAGES_EN: AppMessages = {
  instanceSelector: {
    greeting: 'Hi',
    search: {
      placeholder: 'Search your instance',
      noInstancesFound: 'No instances found'
    },
    showAll: 'Show all ({counter})',
    showLess: 'Show less',
    noInstancesFound: 'You don\'t have access to any instance, please contact support or login with other account'
  },
  domains: {
    [DomainEnum.SEARCH]: 'search',
    [DomainEnum.BROWSE]: 'navigation'
  },
  common: 'common',
  features: {
    [FeatureIdEnum.YEARLY_SUMMARY]: 'Yearly Summary',

    [FeatureIdEnum.ANALYTICS]: 'Analytics',
    [FeatureIdEnum.OVERALL]: 'Overall',
    [FeatureIdEnum.QUERIES]: 'Queries',

    [FeatureIdEnum.INSIGHTS]: 'Insights',
    [FeatureIdEnum.NOW]: 'Now',
    [FeatureIdEnum.ORIGINS]: 'Origins',
    [FeatureIdEnum.KEYWORDS]: 'Terms',

    [FeatureIdEnum.PLAY]: 'Play',
    [FeatureIdEnum.EQUALIZE]: 'Equalize',
    [FeatureIdEnum.EQUALIZE_DASHBOARD]: 'Equalize',
    [FeatureIdEnum.SYNONYM]: 'Synonymize',
    [FeatureIdEnum.SYNONYM_DASHBOARD]: 'Synonymize',
    [FeatureIdEnum.BLACKLIST]: 'Blacklist',
    [FeatureIdEnum.PROMOTION]: 'Promotion',
    [FeatureIdEnum.REDIRECTION]: 'Redirection',
    [FeatureIdEnum.LINK]: 'Link',
    [FeatureIdEnum.ATTRIBUTES_RANKING]: 'Attribute ranking',
    [FeatureIdEnum.PRODUCTS_RANKING]: 'Product ranking',
    [FeatureIdEnum.BOOST]: 'Boost',
    [FeatureIdEnum.CONFIGURATION]: 'Configuration',
    [FeatureIdEnum.RELATED_TAGS]: 'Related tags',

    [FeatureIdEnum.EXPLAIN]: 'Explain',

    [FeatureIdEnum.AUDIT]: 'Activity Stream',

    [FeatureIdEnum.INDEX]: 'Index',

    [FeatureIdEnum.ADMIN]: 'Admin',
    [FeatureIdEnum.INSTANCE]: 'Instances',
    [FeatureIdEnum.PERMISSIONS]: 'Permissions',
    [FeatureIdEnum.FILTERS]: 'Filters',
    [FeatureIdEnum.KPIS]: 'KPIs',
    [FeatureIdEnum.CATALOG]: 'Catalog',
    [FeatureIdEnum.TOOLS]: 'Tools',
    [FeatureIdEnum.USERS]: 'Users',

    [FeatureIdEnum.ACCOUNT]: 'Account'
  },
  routes: {
    home: 'Playboard',

    createEqualize: 'New equalize',
    updateEqualize: 'Edit equalize',
    createSynonym: 'New synonym',
    updateSynonym: 'Edit synonym',
    createBlacklist: 'New blacklist',
    updateBlacklist: 'Edit blacklist',
    createPromotion: 'New promotion',
    updatePromotion: 'Edit promotion',
    createRedirection: 'New redirection',
    updateRedirection: 'Edit redirection',
    createLink: 'New link',
    updateLink: 'Edit link',
    createAttributesRanking: 'New attribute ranking',
    updateAttributesRanking: 'Edit attribute ranking',
    createProductsRanking: 'New product ranking',
    updateProductsRanking: 'Edit product ranking',
    createBoost: 'New Boost',
    updateBoost: 'Update Boost',
    createConfiguration: 'New configuration',
    updateConfiguration: 'Update configuration',
    createRelatedTags: 'New related tags',
    updateRelatedTags: 'Update related tags',

    createInstance: 'New instance',
    updateInstance: 'Update instance',
    createUser: 'New User',
    updateUser: 'Edit User',

    logout: 'Logout'
  },
  fullscreen: {
    close: 'Close fullscreen mode',
    open: 'Open fullscreen mode'
  },
  firstLogin: {
    modal: {
      title: 'New playboard',
      steps: {
        [FirstLoginStepEnum.INTRO]: {
          title: 'Welcome back!',
          content: 'Check out what’s new on your Playboard to make the most of your search data.'
        },
        [FirstLoginStepEnum.USER_METRICS]: {
          title: 'User metrics',
          content: 'New Funnel with new user-related KPIs! How many users are interacting with your search? What about recurrency? How many sessions are done by user?'
        },
        [FirstLoginStepEnum.NO_RESULTS_RATIO]: {
          title: 'No Results ratio',
          content: 'Improve your customers search experience monitoring the No Results.'
        },
        [FirstLoginStepEnum.CHECKOUT_RATIO]: {
          title: 'Checkout',
          content: 'Easily explore beyond the Add to Cart! Checkout KPI is now available for you to track the search attribution.'
        },
        [FirstLoginStepEnum.QUERIES_DISTRIBUTION]: {
          title: 'Search Queries Distribution',
          content: 'Queries Distribution gives you a complete understanding of search performance by language, device or store.'
        },
        [FirstLoginStepEnum.GLOBAL_QUERIES]: {
          title: 'Detailed analysis at query level',
          content: 'Dig deeper into most popular queries in your search! Search them out and see its performance by checking the funnel.'
        },
        [FirstLoginStepEnum.COMPARISON_PERIODS]: {
          title: 'Comparison periods available',
          content: 'Let’s compare your search performance. Easily check the gaps and variances between different periods of time.'
        },
        [FirstLoginStepEnum.MULTISELECTABLE_FILTERS]: {
          title: 'Multi selection functionality',
          content: 'Let’s aggregate data! Now, this is feasible with the new multiselection functionality in analytics filters.'
        }
      },
      actions: {
        back: 'Back',
        next: 'Next',
        finish: 'Finish',
        exit: 'No, thanks',
        close: 'Close',
        fullscreen: {
          on: 'Fullscreen',
          off: 'Exit fullscreen'
        }
      }
    }
  },
  pageNotFound: {
    introduction: 'We’re sorry but the page you’re looking for no longer exists.',
    redirection: `Visit the {homeUrl} or <a href="${ supportLink }" target="_blank">contact us</a> about the problem.`,
    homepage: 'homepage'
  }
};

const APP_MESSAGES_ES: AppMessages = {
  instanceSelector: {
    greeting: '¡Hola',
    search: {
      placeholder: 'Busca tu instancia',
      noInstancesFound: 'No se han encontrado instancias'
    },
    showAll: 'Mostrar todas ({counter})',
    showLess: 'Mostrar menos',
    noInstancesFound: 'No tienes acceso a ninguna instancia. Por favor, contacta con soporte o accede con otra cuenta'
  },
  domains: {
    [DomainEnum.SEARCH]: 'búsqueda',
    [DomainEnum.BROWSE]: 'navegación'
  },
  common: 'común',
  features: {
    [FeatureIdEnum.YEARLY_SUMMARY]: 'Yearly Summary',

    [FeatureIdEnum.ANALYTICS]: 'Analytics',
    [FeatureIdEnum.OVERALL]: 'Overall',
    [FeatureIdEnum.QUERIES]: 'Queries',

    [FeatureIdEnum.INSIGHTS]: 'Insights',
    [FeatureIdEnum.NOW]: 'Now',
    [FeatureIdEnum.ORIGINS]: 'Origins',
    [FeatureIdEnum.KEYWORDS]: 'Terms',

    [FeatureIdEnum.PLAY]: 'Play',
    [FeatureIdEnum.EQUALIZE]: 'Equalize',
    [FeatureIdEnum.EQUALIZE_DASHBOARD]: 'Equalize',
    [FeatureIdEnum.SYNONYM]: 'Synonymize',
    [FeatureIdEnum.SYNONYM_DASHBOARD]: 'Synonymize',
    [FeatureIdEnum.BLACKLIST]: 'Blacklist',
    [FeatureIdEnum.PROMOTION]: 'Promotion',
    [FeatureIdEnum.REDIRECTION]: 'Redirection',
    [FeatureIdEnum.LINK]: 'Link',
    [FeatureIdEnum.ATTRIBUTES_RANKING]: 'Attribute ranking',
    [FeatureIdEnum.PRODUCTS_RANKING]: 'Product ranking',
    [FeatureIdEnum.BOOST]: 'Boost',
    [FeatureIdEnum.CONFIGURATION]: 'Configuración',
    [FeatureIdEnum.RELATED_TAGS]: 'Related tags',

    [FeatureIdEnum.EXPLAIN]: 'Explain',

    [FeatureIdEnum.AUDIT]: 'Activity Stream',

    [FeatureIdEnum.INDEX]: 'Index',

    [FeatureIdEnum.ADMIN]: 'Admin',
    [FeatureIdEnum.INSTANCE]: 'Instancias',
    [FeatureIdEnum.PERMISSIONS]: 'Permisos',
    [FeatureIdEnum.FILTERS]: 'Filtros',
    [FeatureIdEnum.KPIS]: 'KPIs',
    [FeatureIdEnum.CATALOG]: 'Catálogo',
    [FeatureIdEnum.TOOLS]: 'Herramientas',
    [FeatureIdEnum.USERS]: 'Usuarios',

    [FeatureIdEnum.ACCOUNT]: 'Cuenta'
  },
  routes: {
    home: 'Playboard',

    createEqualize: 'Nuevo equalize',
    updateEqualize: 'Editar equalize',
    createSynonym: 'Nuevo sinónimo',
    updateSynonym: 'Editar sinónimo',
    createBlacklist: 'Nueva blacklist',
    updateBlacklist: 'Editar blacklist',
    createPromotion: 'Nueva promotion',
    updatePromotion: 'Editar promotion',
    createRedirection: 'Nueva redirection',
    updateRedirection: 'Editar redirection',
    createLink: 'Nuevo link',
    updateLink: 'Editar link',
    createAttributesRanking: 'Nuevo attribute ranking',
    updateAttributesRanking: 'Editar attribute ranking',
    createProductsRanking: 'Nuevo product ranking',
    updateProductsRanking: 'Editar product ranking',
    createBoost: 'Nuevo Boost',
    updateBoost: 'Editar Boost',
    createConfiguration: 'Nueva configuración',
    updateConfiguration: 'Editar configuración',
    createRelatedTags: 'Nuevas related tags',
    updateRelatedTags: 'Editar related tags',

    createInstance: 'Nueva instancia',
    updateInstance: 'Editar instancia',
    createUser: 'Nuevo Usuario',
    updateUser: 'Editar Usuario',

    logout: 'Cerrar sesión'
  },
  fullscreen: {
    close: 'Cerrar modo pantalla completa',
    open: 'Abrir modo pantalla completa'
  },
  firstLogin: {
    modal: {
      title: 'Nuevo playboard',
      steps: {
        [FirstLoginStepEnum.INTRO]: {
          title: '¡Bienvenido de nuevo!',
          content: '¡Novedades en el Playboard! Aprovecha al máximo tus datos de búsqueda.'
        },
        [FirstLoginStepEnum.USER_METRICS]: {
          title: 'Métricas de usuario',
          content: '¡Un nuevo funnel con KPIs relacionadas con los usuarios! ¿Cuántos usuarios interactúan con tu búsqueda? ¿Cuántas sesiones hace cada usuario?'
        },
        [FirstLoginStepEnum.NO_RESULTS_RATIO]: {
          title: 'Ratio No Results',
          content: 'Mejora la experiencia de búsqueda de tus usuarios controlando el ratio de No Results.'
        },
        [FirstLoginStepEnum.CHECKOUT_RATIO]: {
          title: 'Ratio Checkout',
          content: 'Explora más allá del Add To Cart. El KPI Checkout ahora está disponible para que puedas realizar un seguimiento de tu atribución de búsqueda.'
        },
        [FirstLoginStepEnum.QUERIES_DISTRIBUTION]: {
          title: 'Distribución de queries',
          content: 'La distribución de queries te da una visión completa del rendimiento de tus búsquedas por idioma, dispositivo o tienda.'
        },
        [FirstLoginStepEnum.GLOBAL_QUERIES]: {
          title: 'Análisis detallado a nivel de query',
          content: '¡Analiza las queries más populares de tu búsqueda! Escribe la query y comprueba su rendimiento consultando el funnel.'
        },
        [FirstLoginStepEnum.COMPARISON_PERIODS]: {
          title: 'Filtros de comparación de períodos de tiempo',
          content: 'Comparemos el rendimiento global de la búsqueda. Verifica fácilmente las brechas y variaciones entre diferentes períodos de tiempo.'
        },
        [FirstLoginStepEnum.MULTISELECTABLE_FILTERS]: {
          title: 'Filtros multi-seleccionables',
          content: '¡Agrega, selecciona o elimina datos para enfocar tu análisis!'
        }
      },
      actions: {
        back: 'Atrás',
        next: 'Siguiente',
        finish: 'Finalizar',
        exit: 'No, gracias',
        close: 'Cerrar',
        fullscreen: {
          on: 'Pantalla completa',
          off: 'Salir de pantalla completa'
        }
      }
    }
  },
  pageNotFound: {
    introduction: 'Lo sentimos pero la página que está buscando ya no existe.',
    redirection: `Visita la {homeUrl} o <a href="${ supportLink }" target="_blank">contáctanos</a> sobre el problema.`,
    homepage: 'página de inicio'
  }
};

/* tslint:enable:max-line-length */

export const APP_MESSAGES: Dictionary<{ app: AppMessages }> = {
  [LocaleEnum.ENGLISH]: {
    app: APP_MESSAGES_EN
  },
  [LocaleEnum.SPANISH]: {
    app: APP_MESSAGES_ES
  }
};
